"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDocument = serializeDocument;
const browser_core_1 = require("@datadog/browser-core");
const serializeNode_1 = require("./serializeNode");
const serializationStats_1 = require("./serializationStats");
function serializeDocument(document, configuration, scope, serializationContext) {
    const serializationStart = (0, browser_core_1.timeStampNow)();
    const serializedNode = (0, serializeNode_1.serializeNodeWithId)(document, configuration.defaultPrivacyLevel, {
        serializationContext,
        configuration,
        scope,
    });
    (0, serializationStats_1.updateSerializationStats)(serializationContext.serializationStats, 'serializationDuration', (0, browser_core_1.elapsed)(serializationStart, (0, browser_core_1.timeStampNow)()));
    // We are sure that Documents are never ignored, so this function never returns null
    return serializedNode;
}
//# sourceMappingURL=serializeDocument.js.map